import { Component } from "@angular/core";
import { FirebaseService } from "./services/firebase.service";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
})
export class AppComponent {
  title =
    "ArchitectUI - Angular 7 Bootstrap 5 & Material Design Admin Dashboard Template";

  constructor(private firebaseService: FirebaseService) {}
  ngOnInit() {
    this.firebaseService.requestPermission();

    this.firebaseService.listen();
  }
}
